import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[imageUploadDefault]',
  standalone: false,
})
export class ImageUploadDefaultDirective {
  readonly vc = inject<TemplateRef<any>>(TemplateRef);
}
